module.exports = __webpack_public_path__ + "static/media/ja.9338847c.ogg";